import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {AllModulesComponent} from "./all-modules.component";
import {AuthGuard} from '../sharing/AuthGuard';

const routes: Routes = [
    {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
    },
    {
        path: "",
        component: AllModulesComponent,
        children: [
            {
                path: "employees",
                loadChildren: () =>
                    import("./employees/employees.module").then((m) => m.EmployeesModule),
                canActivate: [AuthGuard]
            },
            {
                path: "recruitment",
                loadChildren: () =>
                    import("./recruitment/recruitment.module").then(
                        (m) => m.RecruitmentModule
                    ),
                canActivate: [AuthGuard]
            },
            {
                path: "contracts",
                loadChildren: () =>
                    import("./contracts/contract.module").then(
                        (m) => m.ContractModule
                    ),
                canActivate: [AuthGuard]
            },
            {
                path: "timemanagement",
                loadChildren: () =>
                    import("./timemanagement/time-management.module").then(
                        (m) => m.TimeManagementModule),
                canActivate: [AuthGuard]
            },
          {
            path: 'teams',
            loadChildren: () => import('./team/team.module').then(m => m.TeamModule),
              canActivate: [AuthGuard]
          },
            {
                path: 'cfrs',
                loadChildren: () => import('./cfrs/cfrs.module').then(m => m.CfrsModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'organization_model',
                loadChildren: () => import('./organization-model/organization-model.module').then(m => m.OrganizationModelModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'salary',
                loadChildren: () => import('./salary/salary.module').then(m => m.SalaryModule),
                canActivate: [AuthGuard]
            }
]}
    
         
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AllModulesRoutingModule {
}
